import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useRef, useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from "../ActionButtons";
// import AskCancelModal from "../AskCancelModal";

import { standardWeight_Walkway } from '../../../lib/data/standard-weight';

const WalkwayForm = ({ onSaveStructure, onChangeWeightSummary, walkways, beltWidth }) => {
    const [isShow, setIsShow] = useState(walkways?.length || false);
    const [newWalkway, setNewWalkway] = useState(walkways || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    const [sectionCategory, setSectionCategory] = useState('0');
    const [deckCategory, setDeckCategory] = useState('0');
    const [length, setLength] = useState('');
    const [standardWeight, setStandardWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalLength, setTotalLength] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /* standard weight libray에서 해당 벨트폭을 뽑아서 저장한다. */
    const weightLibrary = useRef(null);

    /* category 설명하는 text */
    const sectionCategoryText = useRef({
        0: 'Single Side',
        1: 'Both Side',
        // '2': 'Dual Parallel',
    });

    const deckCategoryText = useRef({
        // '0': 'Grating, I25',
        1: 'Checkered Plate, 4.5t',
        2: 'Expanded Metal, X-xx',
    });

    /*  처음 props로 넘어온 walkways를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialWalkway = useRef(walkways || []);

    /* 벨트폭에 해당하는 Weight Table을 가져온다 */
    useEffect(() => {
        if (!standardWeight_Walkway || !beltWidth) return;
        const library = standardWeight_Walkway.find((item) => item.beltWidth === parseInt(beltWidth));
        if (!library) {
            alert('Check Belt Width!!');
            return;
        }
        weightLibrary.current = library;
    }, [beltWidth]);

    /* 기준 중량 가져오기 함수 */
    // const getStandardWeight = useCallback((sectionCategory, deckCategory) => {
    //     if (!weightLibrary.current) return;

    //     const index = sectionCategory * 3 + deckCategory;
    //     return weightLibrary.current.standardWeight[index];
    // }, []);

    /* 기준 중량 가져오기 */
    useEffect(() => {
        if (!sectionCategory || !deckCategory) return;
        let _standardWeight;
        if (sectionCategory === '0') {
            // Single
            if (deckCategory === '1') {
                // Checkered Plate
                _standardWeight = 61.5;
            } else {
                // Expanded Metal
                _standardWeight = 48.0;
            }
        } else {
            // Dual
            if (deckCategory === '1') {
                // Checkered Plate
                _standardWeight = 123.0;
            } else {
                // Expanded Metal
                _standardWeight = 96.0;
            }
        }
        setStandardWeight(_standardWeight);
    }, [deckCategory, sectionCategory]);

    /* 단위 중량 및 중량 자동 계산 */
    useEffect(() => {
        // if (!length || !standardWeight || !factor) {
        //     return;
        // }
        const _weight = Math.ceil(length * standardWeight * factor);
        setWeight(_weight);
    }, [factor, length, standardWeight]);

    /* 마지막 ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newWalkway.length) {
            return 0;
        }
        return Math.max(...newWalkway.map((item) => Number(item.id.substring(3))), 0);
    }, [newWalkway]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`WW-${getLastId() * 1 + 1}`);
        // setFactor('');
        setLength('');
        setWeight('');
    }, [getLastId]);

    /* 전체 길이 계산 함수 */
    const getTotalLength = useCallback((items) => {
        const _totalLength = items.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.length);
        }, 0);
        setTotalLength(_totalLength);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((items) => {
        const _totalWeight = items.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, []);

    /* 추가 버튼을 누르면 newWalkway에 walkway 추가 */
    const onAddWalkway = useCallback(() => {
        if (!length || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const walkway = {
            id,
            sectionCategory: sectionCategoryText.current[`${sectionCategory}`],
            deckCategory: deckCategoryText.current[`${deckCategory}`],
            standardWeight,
            factor,
            length,
            weight,
        };
        setNewWalkway((prev) => [...prev, walkway]);
        setIsChanged(true);
    }, [id, sectionCategory, deckCategory, standardWeight, factor, length, weight]);

    /* 삭제 버튼을 누르면 해당 walkway 삭제 */
    const onDeleteWalkway = useCallback((id) => {
        setNewWalkway((prev) => prev.filter((item) => item.id !== id));
        setIsChanged(true);
    }, []);

    /* newWalkway에 변화가 생기면 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        getTotalLength(newWalkway);
        getTotalWeight(newWalkway);
        initializeForm();
        onSaveStructure({
            key: 'walkway',
            value: newWalkway,
        });
        onChangeWeightSummary({
            key: 'walkway',
            value: {
                totalLength,
                totalWeight,
            },
        });
    }, [
        getTotalLength,
        getTotalWeight,
        initializeForm,
        newWalkway,
        onChangeWeightSummary,
        onSaveStructure,
        totalLength,
        totalWeight,
    ]);

    // const onSaveWalkway = useCallback(() => {
    //     onSaveStructure({
    //         key: 'walkway',
    //         value: newWalkway,
    //     });
    //     onChangeWeightSummary({
    //         key: 'walkway',
    //         value: {
    //             totalLength,
    //             totalWeight,
    //         },
    //     });
    // }, [newWalkway, onChangeWeightSummary, onSaveStructure, totalLength, totalWeight]);

    /* 변경 사항을 취소하면 newWalkway를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewWalkway(initialWalkway.current);
    //     onSaveStructure({
    //         key: 'walkway',
    //         value: initialWalkway.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'walkway',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <WalkwayFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Walkway</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalLength} m</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>Section Type</th>
                                <th>Deck Type</th>
                                <th>
                                    Standard W't <br />
                                    (kg/m)
                                </th>
                                <th>Factor</th>
                                <th>
                                    Length <br /> (m)
                                </th>
                                <th>중량(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newWalkway &&
                                newWalkway.map((walkway, index) => (
                                    <tr key={index}>
                                        <td>{walkway.id}</td>
                                        <td>{walkway.sectionCategory}</td>
                                        <td>{walkway.deckCategory}</td>
                                        <td>{walkway.standardWeight}</td>
                                        <td>{walkway.factor}</td>
                                        <td>{walkway.length}</td>
                                        <td>{walkway.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteWalkway(walkway.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td>
                                    <div className="input-radio">
                                        <label>
                                            <input
                                                type="radio"
                                                name="sectionCategory"
                                                value="0"
                                                onChange={(e) => setSectionCategory(e.target.value)}
                                            />
                                            <span>Single Side</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="sectionCategory"
                                                value="1"
                                                onChange={(e) => setSectionCategory(e.target.value)}
                                            />
                                            <span>Both Side</span>
                                        </label>
                                        {/* <label><input type="radio" name="sectionCategory" value="2" onChange={(e) => setSectionCategory(e.target.value)} /><span>Dual Parallel</span></label> */}
                                    </div>
                                </td>
                                <td>
                                    <div className="input-radio">
                                        {/* <label><input type="radio" name="deckCategory" value="0" onChange={(e) => setDeckCategory(e.target.value)} /><span>Grating</span></label> */}
                                        <label>
                                            <input
                                                type="radio"
                                                name="deckCategory"
                                                value="1"
                                                onChange={(e) => setDeckCategory(e.target.value)}
                                            />
                                            <span>Checkered</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="deckCategory"
                                                value="2"
                                                onChange={(e) => setDeckCategory(e.target.value)}
                                            />
                                            <span>Expanded</span>
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    <StyledInput readOnly value={standardWeight} />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={length}
                                        onChange={(e) => setLength(e.target.value)}
                                    />
                                </td>
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddWalkway}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={5}>Walkway Total</td>
                                <td>{totalLength}</td>
                                <td>{totalWeight}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveWalkway} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </WalkwayFormBlock>
    );
};

export default WalkwayForm;

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const WalkwayFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }
    .weight {
        // min-width: 70px;
    }
    .input-radio {
        display: flex;
        flex-direction: column;
        // margin: 0 1rem;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.25rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
    .right-align {
        text-align: right;
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    // color: ${palette.cyan[8]};
    &:hover {
        background: ${palette.gray[3]};
    }
`;
